function shouldShowFeedback(flowType) {
  switch (flowType) {
    case "training-in-order":
    case "training-random":
      return true;
    default:
      return false;
  }
}

export { shouldShowFeedback };
//# sourceMappingURL=util.should-show-feedback.js.map
